document.addEventListener("DOMContentLoaded", function () {
  const paginatedList = document.getElementById("paginated-list");
  if (!paginatedList) return;

  const paginationLimit = parseInt(
    paginatedList.getAttribute("data-pagination-limit"),
    10
  );
  const totalPages = parseInt(
    paginatedList.getAttribute("data-total-pages"),
    10
  );
  const paginationNumbers = document.getElementById("pagination-numbers");
  const nextButton = document.getElementById("next-button");
  const prevButton = document.getElementById("prev-button");
  const listItems = document.querySelectorAll(".paginated-listitem");
  const totalItems = listItems.length;
  let currentPage = 1;

  // Check URL for page parameter
  const urlParams = new URLSearchParams(window.location.search);
  const pageParam = urlParams.get("p");
  if (pageParam && !isNaN(parseInt(pageParam))) {
    currentPage = parseInt(pageParam);
  }

  // Debounce function for performance
  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  // Setup lazy loading with intersection observer
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  };

  const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = entry.target;
        const imageUrl = target.getAttribute("data-background");

        if (imageUrl) {
          // Add loading state to parent block
          const recipeBlock = target.closest(".recept-block");
          if (recipeBlock) {
            recipeBlock.classList.add("loading");
          }

          // Create an image to preload
          const img = new Image();
          img.onload = function () {
            // Only proceed if the recipe block is still visible
            if (!target.closest(".recept-block").classList.contains("hidden")) {
              target.style.backgroundImage = `url('${imageUrl}')`;
              target.removeAttribute("data-background");
              target.classList.remove("lazy-background");

              // Remove loading state from parent recipe block when image is loaded
              if (recipeBlock) {
                recipeBlock.classList.remove("loading");
              }
            }
            observer.unobserve(target);
          };
          img.src = imageUrl;
        }
      }
    });
  };

  const observer = new IntersectionObserver(
    handleIntersection,
    observerOptions
  );

  // Setup pagination numbers with ellipses for large page counts
  const getPaginationNumbers = () => {
    if (totalPages <= 1) return;

    // Clear any existing pagination
    paginationNumbers.innerHTML = "";

    // Determine page range to show based on current page
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);

    // Always show at least 5 pages if available
    if (endPage - startPage + 1 < 5) {
      if (currentPage < totalPages / 2) {
        endPage = Math.min(startPage + 4, totalPages);
      } else {
        startPage = Math.max(endPage - 4, 1);
      }
    }

    // Add first page if not in range
    if (startPage > 1) {
      appendPageNumber(1);

      // Add ellipsis if there's a gap
      if (startPage > 2) {
        const ellipsis = document.createElement("span");
        ellipsis.className = "pagination-ellipsis";
        ellipsis.textContent = "..."; // Using regular dots
        paginationNumbers.appendChild(ellipsis);
      }
    }

    // Add the page numbers in the determined range
    for (let i = startPage; i <= endPage; i++) {
      appendPageNumber(i);
    }

    // Add last page if not in range
    if (endPage < totalPages) {
      // Add ellipsis if there's a gap
      if (endPage < totalPages - 1) {
        const ellipsis = document.createElement("span");
        ellipsis.className = "pagination-ellipsis";
        ellipsis.textContent = "..."; // Using regular dots
        paginationNumbers.appendChild(ellipsis);
      }

      appendPageNumber(totalPages);
    }
  };

  const appendPageNumber = (index) => {
    const pageNumber = document.createElement("button");
    pageNumber.className = "pagination-number";
    pageNumber.innerHTML = index;
    pageNumber.setAttribute("page-index", index);
    pageNumber.setAttribute("aria-label", "Page " + index);

    paginationNumbers.appendChild(pageNumber);
  };

  const disableButton = (button) => {
    button.classList.add("disabled");
    button.setAttribute("disabled", true);
  };

  const enableButton = (button) => {
    button.classList.remove("disabled");
    button.removeAttribute("disabled");
  };

  const handlePageButtonsStatus = () => {
    if (currentPage === 1) {
      disableButton(prevButton);
    } else {
      enableButton(prevButton);
    }

    if (currentPage === totalPages) {
      disableButton(nextButton);
    } else {
      enableButton(nextButton);
    }
  };

  const handleActivePageNumber = () => {
    document.querySelectorAll(".pagination-number").forEach((button) => {
      button.classList.remove("active");
      const pageIndex = Number(button.getAttribute("page-index"));
      if (pageIndex == currentPage) {
        button.classList.add("active");
      }
    });
  };

  const initLazyLoading = () => {
    const lazyBackgrounds = document.querySelectorAll(
      ".lazy-background:not(.hidden)"
    );
    lazyBackgrounds.forEach((bg) => observer.observe(bg));
  };

  const setCurrentPage = (pageNum, shouldScroll = false) => {
    currentPage = pageNum;

    // Regenerate pagination with new current page
    getPaginationNumbers();
    handleActivePageNumber();
    handlePageButtonsStatus();

    const prevRange = (pageNum - 1) * paginationLimit;
    const currRange = pageNum * paginationLimit;

    // Add loading state to items before showing them
    listItems.forEach((item, index) => {
      if (index >= prevRange && index < currRange) {
        // Add loading class temporarily to items about to be shown
        if (item.classList.contains("hidden")) {
          item.classList.add("loading");
        }
        item.classList.remove("hidden");
        item.removeAttribute("hidden");
      } else {
        item.classList.add("hidden");
        item.setAttribute("hidden", "");
        item.classList.remove("loading"); // Remove loading from hidden items
      }
    });

    // Initialize lazy loading for newly visible items
    initLazyLoading();

    // Ensure all visible items that don't load an image properly
    // don't stay in loading state forever
    setTimeout(() => {
      listItems.forEach((item, index) => {
        if (!item.classList.contains("hidden")) {
          item.classList.remove("loading");
        }
      });
    }, 1000); // Fallback timeout of 1 seconds to clear loading state

    // Update URL without reloading page
    const url = new URL(window.location);
    if (pageNum === 1) {
      url.searchParams.delete("p");
    } else {
      url.searchParams.set("p", pageNum);
    }
    history.pushState({ page: pageNum }, "", url);

    // Only scroll if explicitly requested (i.e., from a button click)
    if (shouldScroll) {
      debounce(() => {
        paginatedList.scrollIntoView({ behavior: "smooth" });
      }, 100)();
    }

    // Re-attach event listeners for pagination numbers
    attachPaginationEvents();
  };

  const attachPaginationEvents = () => {
    document.querySelectorAll(".pagination-number").forEach((button) => {
      const pageIndex = Number(button.getAttribute("page-index"));
      if (pageIndex) {
        button.addEventListener("click", () => {
          setCurrentPage(pageIndex, true); // Add shouldScroll=true parameter
        });
      }
    });
  };

  // Initialize
  getPaginationNumbers();
  handleActivePageNumber();
  handlePageButtonsStatus();
  initLazyLoading();

  // Initial page setup - don't scroll
  const initialPage = currentPage;
  setCurrentPage(initialPage, false);

  // Event listeners for next/previous - add shouldScroll=true parameter
  prevButton.addEventListener("click", () => {
    setCurrentPage(currentPage - 1, true);
  });

  nextButton.addEventListener("click", () => {
    setCurrentPage(currentPage + 1, true);
  });

  // Handle browser back/forward - don't scroll on browser navigation
  window.addEventListener("popstate", function (e) {
    if (e.state && e.state.page) {
      setCurrentPage(e.state.page, false);
    } else {
      // If no state, assume page 1
      setCurrentPage(1, false);
    }
  });
});
